import { memo } from 'react';
import { MButton } from '@Components/Base';
import { Form } from 'antd';

import { FooterActions } from '@Enum/index';

interface ApprovalButtonsProps {
  onAction: (action: FooterActions, payload?: string) => void;
  approveBtnName?: string;
}

const ApprovalButtons: React.FC<ApprovalButtonsProps> = ({
  onAction,
  approveBtnName = 'Approve',
}) => {
  return (
    <>
      <Form.Item>
        <MButton
          type="tertiary"
          onClick={() => onAction(FooterActions.REASSIGN)}
          style={{ marginRight: '24px' }}
        >
          Re-assign
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton
          danger
          onClick={() => onAction(FooterActions.REJECT)}
          style={{ marginRight: '24px' }}
        >
          Reject
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton type="primary" onClick={() => onAction(FooterActions.APPROVE)}>
          {approveBtnName}
        </MButton>
      </Form.Item>
    </>
  );
};

export default memo(ApprovalButtons);
